import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const clearFieldBtn = css`
  position: relative;
  left: 8px;
  min-width: 24px;
  height: 24px;
  width: 24px;
  padding: ${theme.spacing(0.5)};
`;
